


























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import TextMonthChangePicker from "./TextMonthChangePicker.vue";

@Component({
  components: {
    TextMonthChangePicker
  }
})
export default class MonthPickerDialog extends Vue {
  @Prop({ default: "【タイトル】" }) title!: string;
  @Prop({ default: "OK" }) buttonOk!: string;
  @Prop({ default: "キャンセル" }) buttonCancel!: string;
  @Prop({ default: false }) isActive!: boolean;

  //リアルタイム今月
  private todaymonth(): string {
    const date = new Date();
    date.setTime(date.getTime() + 1000 * 60 * 60 * 9);
    const todaymonth = date.toISOString().substr(0, 7);
    return todaymonth;
  }

  //出力タイプ
  private innerYearmonth = this.todaymonth();

  //決定
  @Emit()
  private selected() {
    return this.innerYearmonth;
  }

  //キャンセル
  @Emit()
  private cancel() {
    return;
  }
}
